import { matchesAirror, NO_PERMISSION, NO_WORKSPACE_PERMISSION, NOT_FOUND } from '@air/errors';

/** Deleted or unreachable showcases settle quietly; transient errors may retry once. */
export const isWorkspaceAgentShowcaseMonikerUnresolvableError = (error: unknown): boolean =>
  matchesAirror(error, NOT_FOUND) ||
  matchesAirror(error, NO_PERMISSION) ||
  matchesAirror(error, NO_WORKSPACE_PERMISSION);
